export default __webpack_public_path__ + "static/media/hand-holding-money-danish-krone.c7d07a1a.png";